// Reference pack. Fictional company "Nordlight", a software studio building an
// online store for a retail client. See README.md for the schema.
export default {
  id: 'project-manager',
  occupationId: '66b280672a4e4285b87ebca8',
  occupationName: { en: 'Project manager', ua: 'Менеджер проєктів' },
  format: 'messenger',
  title: { en: 'A day as a project manager', ua: 'День менеджера проєктів' },
  tagline: {
    en: 'Three teams, one slipping deadline and a client who wants a demo on Thursday',
    ua: 'Три команди, дедлайн, що сповзає, і клієнт, який хоче демо в четвер'
  },
  minutes: 10,
  intro: {
    en: 'You run the "Storefront" project at Nordlight, a 40-person software studio. The client is a regional shoe retailer moving sales online. It is Tuesday of sprint week two, the demo is on Thursday, and the payment integration is behind.',
    ua: 'Ти ведеш проєкт «Вітрина» у Nordlight, студії розробки на 40 людей. Клієнт — регіональна мережа взуттєвих магазинів, яка виходить в онлайн. Вівторок другого тижня спринту, демо в четвер, а інтеграція оплати відстає.'
  },
  goal: {
    en: 'Get to Thursday with a demo the client trusts and a team that still talks to you',
    ua: 'Дійти до четверга з демо, якому довіряє клієнт, і командою, яка з тобою ще розмовляє'
  },
  kpis: [
    { key: 'delivery', label: { en: 'Delivery', ua: 'Строки' }, start: 55 },
    { key: 'quality', label: { en: 'Quality', ua: 'Якість' }, start: 60 },
    { key: 'team', label: { en: 'Team mood', ua: 'Настрій команди' }, start: 65 }
  ],
  competencies: [
    {
      key: 'priorities',
      label: { en: 'Prioritisation', ua: 'Пріоритизація' },
      skill: { _id: '686282c1aa8e5a92e3bc140a', name: 'Управління часом і розстановка пріоритетів' }
    },
    {
      key: 'people',
      label: { en: 'People', ua: 'Робота з людьми' },
      skill: { _id: '686282c1aa8e5a92e3bc135c', name: 'Робота в команді' }
    },
    {
      key: 'risk',
      label: { en: 'Risk and scope', ua: 'Ризики та обсяг' },
      skill: { _id: '686282c1aa8e5a92e3bc136d', name: 'Управління ризиками' }
    },
    {
      key: 'communication',
      label: { en: 'Communication', ua: 'Комунікація' },
      skill: { _id: '686282c1aa8e5a92e3bc133c', name: 'Комунікативність' }
    },
    {
      key: 'planning',
      label: { en: 'Planning', ua: 'Планування' },
      skill: { _id: '686282c1aa8e5a92e3bc1367', name: 'Планування' }
    }
  ],
  people: [
    {
      key: 'cto',
      name: { en: 'Olena', ua: 'Олена' },
      role: { en: 'CTO', ua: 'CTO' },
      initials: 'OL',
      color: '#30b0c7'
    },
    {
      key: 'dev',
      name: { en: 'Taras', ua: 'Тарас' },
      role: { en: 'Backend developer', ua: 'Бекенд-розробник' },
      initials: 'TA',
      color: '#19857b'
    },
    {
      key: 'junior',
      name: { en: 'Daryna', ua: 'Дарина' },
      role: { en: 'Junior developer', ua: 'Джуніор-розробниця' },
      initials: 'DA',
      color: '#9c27b0'
    },
    {
      key: 'client',
      name: { en: 'Maryna', ua: 'Марина' },
      role: { en: 'Client product owner', ua: 'Продакт-оунер клієнта' },
      initials: 'MA',
      color: '#d5921b'
    },
    {
      key: 'qa',
      name: { en: 'Andrii', ua: 'Андрій' },
      role: { en: 'QA engineer', ua: 'QA-інженер' },
      initials: 'AN',
      color: '#4f9a04'
    },
    {
      key: 'design',
      name: { en: 'Iryna', ua: 'Ірина' },
      role: { en: 'Designer', ua: 'Дизайнерка' },
      initials: 'IR',
      color: '#e25510'
    }
  ],
  steps: [
    {
      type: 'chat',
      id: 's1',
      at: '09:05',
      comp: ['communication', 'risk'],
      traits: ['E', 'S'],
      messages: [
        {
          from: 'dev',
          text: {
            en: 'Bad news. The payment provider sandbox has been down since yesterday and support says "a few days". Integration is 3 days behind.',
            ua: 'Погані новини. Пісочниця платіжного провайдера лежить із вчора, підтримка каже «кілька днів». Інтеграція відстає на 3 дні.'
          }
        },
        {
          from: 'client',
          text: {
            en: 'Morning! Our CEO has blocked Thursday 15:00 for the demo. We are still on, right?',
            ua: 'Доброго ранку! Наш CEO заблокував четвер 15:00 під демо. Ми ж у графіку, так?'
          }
        }
      ],
      prompt: { en: 'What do you write to Maryna?', ua: 'Що пишеш Марині?' },
      options: [
        {
          text: {
            en: 'Thursday stands. The payment step will run on a stub because the provider is down; the live integration lands a week later. Here is the updated plan.',
            ua: 'Четвер у силі. Крок оплати покажемо на заглушці, бо провайдер лежить; жива інтеграція буде на тиждень пізніше. Ось оновлений план.'
          },
          q: 'best',
          fx: { delivery: 5, trust: 5 },
          fb: {
            en: 'The client hears a decision, not a problem. A stubbed demo shows the flow, and the honest date for payments protects you on Thursday.',
            ua: 'Клієнт чує рішення, а не проблему. Демо на заглушці показує сценарій, а чесна дата оплати захищає тебе в четвер.'
          }
        },
        {
          text: {
            en: 'Let me check with the team and come back by tomorrow morning. The sandbox may be up again by then, so it is too early to change anything.',
            ua: 'Дай мені звіритися з командою, повернуся завтра вранці. Пісочниця може ожити, тож зарано щось змінювати.'
          },
          q: 'ok',
          fx: { trust: -2, energy: -5 },
          fb: {
            en: 'Buying a day is defensible, but you now carry the risk alone. If the sandbox stays down, Wednesday is the worst day to break the news.',
            ua: 'Виграти день можна, але ризик тепер на тобі. Якщо пісочниця не оживе, середа — найгірший день для поганих новин.'
          },
          later: {
            after: 2,
            note: {
              en: 'The sandbox is still down. Maryna asks again about Thursday, now copying her CEO.',
              ua: 'Пісочниця досі лежить. Марина знову питає про четвер, тепер у копії її CEO.'
            },
            fx: { trust: -5 }
          }
        },
        {
          text: {
            en: 'Yes, Thursday is on. I will ask Taras to push on payments and we will make it work, the team has handled worse than a sandbox outage.',
            ua: 'Так, четвер у силі. Попрошу Тараса натиснути на оплату, і ми впораємось, команда проходила й гірше, ніж падіння пісочниці.'
          },
          q: 'bad',
          fx: { team: -8, trust: 3 },
          fb: {
            en: 'You promised something Taras cannot deliver, since the blocker is outside the team. When Thursday comes, the client feels misled and the team feels blamed.',
            ua: 'Ти пообіцяв те, чого Тарас не зробить: блокер поза командою. У четвер клієнт почувається обдуреним, а команда — винною.'
          },
          later: {
            after: 3,
            note: {
              en: 'Taras worked two late evenings on a provider he cannot test. Nothing changed, and he is tired.',
              ua: 'Тарас два вечори сидів над провайдером, якого не може протестувати. Нічого не змінилося, а він втомлений.'
            },
            fx: { team: -5, energy: -5 }
          }
        },
        {
          text: {
            en: 'Ask Taras to switch to another payment provider today. There are three others on the market and we cannot depend on one vendor.',
            ua: 'Попросити Тараса сьогодні ж перейти на іншого провайдера. На ринку є ще три, і ми не можемо залежати від одного.'
          },
          q: 'bad',
          fx: { delivery: -8, quality: -5 },
          fb: {
            en: 'A provider switch mid-sprint costs more than the outage: new contracts, new API, new tests. You traded a three-day delay for a two-week one.',
            ua: 'Зміна провайдера посеред спринту коштує більше за простій: новий договір, нове API, нові тести. Ти обміняв три дні затримки на два тижні.'
          }
        }
      ],
      principle: {
        en: 'Bring the client a re-plan, not a status.',
        ua: 'Неси клієнту переплан, а не статус.'
      }
    },
    {
      type: 'triage',
      id: 's2',
      at: '09:40',
      comp: ['priorities'],
      traits: ['C', 'I'],
      text: {
        en: 'Five things landed in your inbox overnight. Put them in the order you will handle them.',
        ua: 'За ніч у вхідних з’явилося п’ять справ. Розстав їх у порядку, в якому візьмешся.'
      },
      items: [
        {
          id: 'bug',
          title: { en: 'Checkout error on production', ua: 'Помилка оформлення на проді' },
          detail: {
            en: "Andrii reports 8% of orders fail at the address step since last night's release.",
            ua: 'Андрій пише: 8% замовлень падають на кроці адреси після вчорашнього релізу.'
          }
        },
        {
          id: 'contract',
          title: { en: 'Contract addendum', ua: 'Додаток до договору' },
          detail: {
            en: 'Legal needs your sign-off by 18:00 today or the next invoice slips a month.',
            ua: 'Юристам потрібен твій підпис до 18:00, інакше наступний рахунок зсувається на місяць.'
          }
        },
        {
          id: 'one',
          title: { en: 'One-on-one with Daryna', ua: 'Зустріч один на один з Дариною' },
          detail: {
            en: 'Scheduled for 11:00, she asked for it last week and has not said why.',
            ua: 'Заплановано на 11:00, вона просила ще минулого тижня й не сказала навіщо.'
          }
        },
        {
          id: 'retro',
          title: { en: 'Prepare the sprint retro', ua: 'Підготувати ретро спринту' },
          detail: {
            en: "Retro is on Friday, the board needs the last sprint's actions reviewed.",
            ua: 'Ретро в п’ятницю, треба переглянути дії з минулого спринту.'
          }
        },
        {
          id: 'risks',
          title: { en: 'Update the risk register', ua: 'Оновити реєстр ризиків' },
          detail: {
            en: 'Monthly review with Olena is next week.',
            ua: 'Місячний перегляд з Оленою наступного тижня.'
          }
        }
      ],
      correctOrder: ['bug', 'contract', 'one', 'retro', 'risks'],
      explain: {
        en: 'Live customers losing orders beats everything with a deadline. The addendum has a hard clock today. The one-on-one is a promise to a person and costs little to keep. Retro and the register have slack.',
        ua: 'Живі клієнти, які втрачають замовлення, важливіші за будь-який дедлайн. У додатку жорсткий час сьогодні. Один на один — обіцянка людині, яку дешево дотримати. Ретро й реєстр мають запас.'
      },
      fx: { ok: { delivery: 5 }, fail: { delivery: -5, energy: -5 } }
    },
    {
      type: 'choice',
      id: 's3',
      at: '10:30',
      comp: ['risk', 'communication'],
      traits: ['E', 'I'],
      text: {
        en: 'Iryna presents the new checkout design on a call with Maryna. Maryna loves it and adds: "Can we also have gift wrapping as an option? Small thing, our marketing really wants it for the launch." The sprint is half done.',
        ua: 'Ірина показує новий дизайн оформлення на дзвінку з Мариною. Марині подобається, і вона додає: «А можна ще опцію подарункової упаковки? Дрібниця, але маркетинг дуже хоче її до запуску». Спринт пройдено наполовину.'
      },
      options: [
        {
          text: {
            en: 'Say yes to the idea, no to "now": estimate it with the team today and offer a trade, either something leaves the sprint or the date moves.',
            ua: 'Сказати «так» ідеї і «ні» слову «зараз»: сьогодні оцінити з командою і запропонувати обмін: або щось виходить зі спринту, або зсувається дата.'
          },
          q: 'best',
          fx: { delivery: 4, trust: 3 },
          fb: {
            en: 'Scope has a price and the client gets to pay it knowingly. You stay the person who makes things possible, not the one who says no.',
            ua: 'Обсяг має ціну, і клієнт платить її свідомо. Ти залишаєшся тим, хто робить речі можливими, а не тим, хто каже «ні».'
          }
        },
        {
          text: {
            en: 'Take it as a stretch goal: the team will do it if time allows, no promises. That keeps the client happy and the sprint commitment unchanged.',
            ua: 'Взяти як додаткову ціль: команда зробить, якщо буде час, без обіцянок. Клієнт задоволений, зобов’язання спринту без змін.'
          },
          q: 'ok',
          fx: { trust: 2, team: -3 },
          fb: {
            en: '"If time allows" is heard as "yes" by the client and as "extra work" by the team. It works once; by the third stretch goal nobody believes the sprint.',
            ua: '«Якщо буде час» клієнт чує як «так», а команда — як «понаднормово». Раз спрацює; після третьої такої цілі спринту вже ніхто не вірить.'
          }
        },
        {
          text: {
            en: 'Decline politely: the sprint is locked, this is how the process works, and we can discuss gift wrapping at the next planning in two weeks.',
            ua: 'Ввічливо відмовити: спринт зафіксований, такий процес, обговоримо упаковку на наступному плануванні за два тижні.'
          },
          q: 'bad',
          fx: { trust: -6 },
          fb: {
            en: 'Process is your tool, not your argument. The client does not care about sprint rules; they hear that their launch idea is not welcome.',
            ua: 'Процес — твій інструмент, а не аргумент. Клієнту байдуже до правил спринту; він чує, що його ідея до запуску не потрібна.'
          }
        },
        {
          text: {
            en: 'Agree on the call, it really is small, and ask Taras and Iryna afterwards to fit it in. The team has absorbed bigger changes before.',
            ua: 'Погодитись на дзвінку, це справді дрібниця, а потім попросити Тараса й Ірину втиснути. Команда перетравлювала й більше.'
          },
          q: 'bad',
          fx: { team: -8, quality: -4 },
          fb: {
            en: 'Small on a slide, not in code: a new option touches cart, price, order and the warehouse export. The team learns that you sell their evenings.',
            ua: 'Дрібниця на слайді, не в коді: нова опція чіпає кошик, ціну, замовлення й експорт на склад. Команда дізнається, що ти продаєш її вечори.'
          },
          later: {
            after: 2,
            note: {
              en: 'Gift wrapping broke the price calculation on staging. Andrii found it an hour before the client check.',
              ua: 'Подарункова упаковка зламала розрахунок ціни на стейджингу. Андрій знайшов це за годину до перевірки клієнтом.'
            },
            fx: { quality: -5 }
          }
        }
      ],
      principle: {
        en: 'Never say no to scope. Say what it costs.',
        ua: 'Не кажи «ні» обсягу. Скажи, скільки він коштує.'
      }
    },
    {
      type: 'numeric',
      id: 's4',
      at: '11:30',
      comp: ['planning'],
      traits: ['I', 'C'],
      text: {
        en: 'Olena asks for a forecast before lunch. The sprint is 10 working days long and the team commits to story points at the start.',
        ua: 'Олена просить прогноз до обіду. Спринт триває 10 робочих днів, команда бере зобов’язання в сторі-поінтах на старті.'
      },
      data: [
        { label: { en: 'Committed points', ua: 'Взято поінтів' }, value: '48' },
        { label: { en: 'Days passed', ua: 'Днів минуло' }, value: '6' },
        { label: { en: 'Points done', ua: 'Поінтів зроблено' }, value: '22' },
        {
          label: { en: 'Sprint length', ua: 'Довжина спринту' },
          value: { en: '10 days', ua: '10 днів' }
        }
      ],
      question: {
        en: 'At the current pace, how many points will be done by the end of day 10?',
        ua: 'За поточним темпом, скільки поінтів буде зроблено до кінця 10-го дня?'
      },
      answer: 36.7,
      tolerance: 0.05,
      unit: { en: 'points', ua: 'поінтів' },
      hint: {
        en: 'Find the points per day so far, then scale to the full sprint.',
        ua: 'Знайди поінти за день на сьогодні, потім помнож на весь спринт.'
      },
      explain: {
        en: '22 points ÷ 6 days = 3.67 points a day. 3.67 × 10 days ≈ 36.7 points, so about 11 of the 48 points will not make it. That is the number Olena needs, not "we will try".',
        ua: '22 поінти ÷ 6 днів = 3,67 поінта на день. 3,67 × 10 днів ≈ 36,7 поінта, тобто близько 11 із 48 не встигнуть. Саме ця цифра потрібна Олені, а не «постараємось».'
      },
      fx: { ok: { delivery: 5 }, fail: { delivery: -4 } }
    },
    {
      type: 'queue',
      id: 's5',
      at: '13:00',
      comp: ['priorities', 'people'],
      traits: ['S', 'C'],
      text: {
        en: 'Back from lunch, four messages wait. Open them in the order you think is right and answer each.',
        ua: 'Після обіду чекають чотири повідомлення. Відкрий їх у тому порядку, який вважаєш правильним, і відповідай на кожне.'
      },
      tickets: [
        {
          id: 't1',
          from: 'dev',
          urgency: 3,
          sla: { en: 'today', ua: 'сьогодні' },
          subject: { en: 'I might be out tomorrow', ua: 'Завтра мене може не бути' },
          body: {
            en: 'Feeling feverish since noon. If I am out tomorrow, nobody else knows the payment code. Just so you know.',
            ua: 'З обіду температура. Якщо завтра мене не буде, платіжний код більше ніхто не знає. Просто щоб ти знав.'
          },
          options: [
            {
              text: {
                en: 'Thanks for flagging. Spend the next hour with Daryna on the payment module and a written handover note, then go home and rest.',
                ua: 'Дякую, що сказав. Приділи наступну годину Дарині та письмовій передачі по платіжному модулю, а потім іди додому і відпочивай.'
              },
              q: 'best',
              fx: { quality: 4, team: 3 },
              fb: {
                en: 'One hour of handover today is cheaper than a day of nobody touching payments tomorrow. Sending him home keeps the rest of the team healthy.',
                ua: 'Година передачі сьогодні дешевша за день без нікого на оплаті завтра. Відправивши його додому, ти бережеш решту команди.'
              }
            },
            {
              text: {
                en: 'Get well soon. Let us see how you feel in the morning; if you are out, we will figure something out with Daryna then.',
                ua: 'Одужуй. Подивимось зранку, як почуваєшся; якщо не буде, тоді щось придумаємо з Дариною.'
              },
              q: 'ok',
              fx: { team: 1 },
              fb: {
                en: 'Kind, but you wait for the risk to happen before acting. Tomorrow morning the knowledge is at home with a fever.',
                ua: 'По-людськи, але ти чекаєш, поки ризик станеться. Завтра зранку знання вдома, з температурою.'
              }
            },
            {
              text: {
                en: 'Please try to push through tomorrow, we only need two more days on payments and then you can take the rest of the week off.',
                ua: 'Будь ласка, спробуй протриматись завтра, нам треба ще два дні по оплаті, а потім бери решту тижня.'
              },
              q: 'bad',
              fx: { team: -8 },
              fb: {
                en: 'You asked a sick person to work and told the team what you value. The handover problem is still unsolved.',
                ua: 'Ти попросив хвору людину працювати й показав команді, що для тебе важливо. Проблема передачі знань не зникла.'
              }
            }
          ]
        },
        {
          id: 't2',
          from: 'qa',
          urgency: 2,
          sla: { en: '2 h', ua: '2 год' },
          subject: { en: 'Test environment is down', ua: 'Тестове середовище лежить' },
          body: {
            en: 'Staging has been returning 502 since 12:40. I cannot test anything for the demo until it is back. DevOps is not answering.',
            ua: 'Стейджинг віддає 502 з 12:40. До демо нічого не можу тестувати, поки не підніметься. Девопс не відповідає.'
          },
          options: [
            {
              text: {
                en: 'Escalate to Olena now with the time it has been down, and ask Andrii to test what he can locally in the meantime.',
                ua: 'Ескалювати Олені зараз із часом простою і попросити Андрія тим часом тестувати локально, що можна.'
              },
              q: 'best',
              fx: { delivery: 3, quality: 3 },
              fb: {
                en: 'Unblocking is the job. One escalation with a number ("down 20 minutes, demo in 2 days") moves faster than three polite pings.',
                ua: 'Розблоковувати — це і є робота. Одна ескалація з цифрою («лежить 20 хвилин, демо за 2 дні») швидша за три ввічливі нагадування.'
              }
            },
            {
              text: {
                en: 'Ask Andrii to keep trying DevOps and to write down everything that is blocked so we know the damage.',
                ua: 'Попросити Андрія далі стукати до девопсів і записувати все заблоковане, щоб знати масштаб.'
              },
              q: 'ok',
              fx: { energy: -3 },
              fb: {
                en: 'Documenting the blockage is useful, but you left the escalation to the person with the least leverage.',
                ua: 'Записати заблоковане корисно, але ескалацію ти залишив людині з найменшим впливом.'
              }
            },
            {
              text: {
                en: 'Tell Andrii this happens often and to use the time for writing test cases; staging usually comes back within the hour.',
                ua: 'Сказати Андрію, що таке буває, і хай пише тест-кейси; стейджинг зазвичай піднімається за годину.'
              },
              q: 'bad',
              fx: { quality: -5 },
              fb: {
                en: '"Usually" is not a plan two days before a demo. You traded a known risk for hope.',
                ua: '«Зазвичай» — не план за два дні до демо. Ти обміняв відомий ризик на надію.'
              }
            }
          ]
        },
        {
          id: 't3',
          from: 'client',
          urgency: 2,
          sla: { en: 'end of day', ua: 'до кінця дня' },
          subject: { en: 'Weekly status report', ua: 'Тижневий статус' },
          body: {
            en: 'Could you send the weekly status by end of day? Our board meets tomorrow and they will ask about the launch.',
            ua: 'Можеш надіслати тижневий статус до кінця дня? Завтра у нас правління, і вони спитають про запуск.'
          },
          options: [
            {
              text: {
                en: 'Reply that it will arrive by 17:30, and block 30 minutes for it right now before the afternoon eats the time.',
                ua: 'Відповісти, що буде до 17:30, і одразу заблокувати 30 хвилин, поки день не з’їв час.'
              },
              q: 'best',
              fx: { trust: 3 },
              fb: {
                en: "A commitment with a time, and a calendar block to back it. The board hears your numbers, not someone's guess.",
                ua: 'Зобов’язання з часом і блок у календарі під нього. Правління чує твої цифри, а не чиюсь здогадку.'
              }
            },
            {
              text: {
                en: 'Send the last report with updated dates now, it mostly still holds, and mention the sandbox issue in one line.',
                ua: 'Надіслати минулий звіт з оновленими датами зараз, він здебільшого актуальний, і згадати пісочницю одним рядком.'
              },
              q: 'ok',
              fx: { trust: 1, energy: 2 },
              fb: {
                en: 'Fast, but a recycled report before a board meeting is where small inaccuracies become big questions.',
                ua: 'Швидко, але перероблений звіт перед правлінням — це місце, де дрібні неточності стають великими питаннями.'
              }
            },
            {
              text: {
                en: "Ask if Thursday's demo can replace the report, since they will see everything live anyway.",
                ua: 'Спитати, чи може демо в четвер замінити звіт, адже вони й так усе побачать наживо.'
              },
              q: 'bad',
              fx: { trust: -5 },
              fb: {
                en: 'The board meets tomorrow, not Thursday. You just made Maryna walk in without numbers.',
                ua: 'Правління завтра, а не в четвер. Ти щойно відправив Марину на засідання без цифр.'
              }
            }
          ]
        },
        {
          id: 't4',
          from: 'cto',
          urgency: 1,
          sla: { en: 'this week', ua: 'цього тижня' },
          subject: { en: 'Quarterly capacity sheet', ua: 'Квартальна таблиця завантаження' },
          body: {
            en: 'Finance needs the capacity sheet for next quarter filled by Friday. Template is in the shared drive.',
            ua: 'Фінансам потрібна таблиця завантаження на наступний квартал до п’ятниці. Шаблон на спільному диску.'
          },
          options: [
            {
              text: {
                en: 'Put it on Thursday after the demo, when the sprint forecast is known, and tell Olena that date.',
                ua: 'Поставити на четвер після демо, коли буде відомий прогноз спринту, і назвати Олені цю дату.'
              },
              q: 'best',
              fx: { energy: 2 },
              fb: {
                en: 'Low urgency gets a date, not a drop-everything. Naming the day is what makes it a commitment and not a dodge.',
                ua: 'Низька терміновість отримує дату, а не «кидаю все». Названий день робить це зобов’язанням, а не відмазкою.'
              }
            },
            {
              text: {
                en: 'Fill it now while it is fresh, it takes 40 minutes and then it is off the list.',
                ua: 'Заповнити зараз, поки свіже, це 40 хвилин, і справа з плеча.'
              },
              q: 'ok',
              fx: { energy: -6 },
              fb: {
                en: 'Forty minutes two days before a demo is not free. You cleared the easiest item instead of the most important one.',
                ua: 'Сорок хвилин за два дні до демо не безкоштовні. Ти закрив найлегшу справу замість найважливішої.'
              }
            },
            {
              text: {
                en: 'Leave it until Friday morning, it is only a spreadsheet and finance always extends the deadline anyway.',
                ua: 'Залишити до ранку п’ятниці, це лише таблиця, та й фінанси завжди подовжують дедлайн.'
              },
              q: 'bad',
              fx: { trust: -4 },
              fb: {
                en: 'Deadlines you silently skip are how a CTO learns you cannot be relied on for the small things either.',
                ua: 'Дедлайни, які ти мовчки пропускаєш, — це як CTO дізнається, що на тебе не можна покластися й у дрібницях.'
              }
            }
          ]
        }
      ]
    },
    {
      type: 'chat',
      id: 's6',
      at: '14:30',
      comp: ['people'],
      traits: ['S', 'E'],
      dilemma: true,
      messages: [
        {
          from: 'dev',
          text: {
            en: '#storefront-dev: The staging build is red again. Daryna pushed without running the tests. This is the second time this week, can someone explain to her how a pipeline works?',
            ua: '#storefront-dev: Стейджинг знову червоний. Дарина запушила без тестів. Другий раз за тиждень, може хтось пояснити їй, як працює пайплайн?'
          }
        },
        {
          from: 'junior',
          text: {
            en: '(DM) I am so sorry. I ran them locally, they passed. I do not know what happened. I can fix it now.',
            ua: '(особисте) Мені дуже шкода. Я ганяла тести локально, вони проходили. Не знаю, що сталося. Можу виправити зараз.'
          }
        }
      ],
      prompt: {
        en: 'Two people are waiting for you. What do you do?',
        ua: 'Двоє людей чекають на тебе. Що робиш?'
      },
      options: [
        {
          text: {
            en: 'In the channel: "Build is the priority, Taras and Daryna please pair on the fix now." Then a private call with Taras about tone, after the build is green.',
            ua: 'У каналі: «Пріоритет — збірка, Тарасе й Дарино, зробіть виправлення разом зараз». Потім приватний дзвінок із Тарасом про тон, коли збірка позеленіє.'
          },
          q: 'best',
          fx: { team: 5, quality: 4 },
          fb: {
            en: "The channel sees calm and a fix, not a trial. The tone problem is real, but it is Taras's problem to hear in private, not the team's to watch.",
            ua: 'Канал бачить спокій і виправлення, а не суд. Проблема тону справжня, але Тарас має почути її приватно, а не команда дивитися.'
          }
        },
        {
          text: {
            en: 'Reply to Daryna first: "Not a disaster, happens to everyone. Fix it with Taras, and we will look at why local and CI differ." Address the channel tone at Friday\'s retro.',
            ua: 'Спочатку Дарині: «Не катастрофа, буває з усіма. Виправ із Тарасом, а потім розберемось, чому локально й у CI різні результати». Тон у каналі винести на ретро в п’ятницю.'
          },
          q: 'best',
          fx: { team: 4, quality: 3 },
          fb: {
            en: 'You protected the person most at risk of quitting and turned the incident into a process question. Waiting for the retro is slower, but the team hears it together.',
            ua: 'Ти захистив людину, яка найближче до звільнення, і перетворив інцидент на питання процесу. Чекати ретро повільніше, але команда почує це разом.'
          }
        },
        {
          text: {
            en: 'Stay out of it, this is an engineering matter. Taras is senior, Daryna will learn faster from him than from a manager stepping in.',
            ua: 'Не втручатись, це інженерне питання. Тарас сеньйор, Дарина навчиться від нього швидше, ніж від менеджера, що втручається.'
          },
          q: 'bad',
          fx: { team: -8 },
          fb: {
            en: 'Public blame with no response from you becomes the team norm. Daryna learned that nobody has her back, which is the lesson you least wanted taught.',
            ua: 'Публічне звинувачення без твоєї реакції стає нормою команди. Дарина засвоїла, що її ніхто не прикриє, і це урок, якого ти найменше хотів.'
          },
          later: {
            after: 2,
            note: {
              en: 'Daryna has gone quiet in the channel and asked HR about internal transfers.',
              ua: 'Дарина замовкла в каналі й спитала HR про внутрішній перехід.'
            },
            fx: { team: -6 }
          }
        },
        {
          text: {
            en: 'Reply in the channel to Taras: "Let us keep it respectful, please." Then ask Daryna to fix the build and add a checklist to the contribution guide.',
            ua: 'Відповісти в каналі Тарасу: «Давайте з повагою, будь ласка». Потім попросити Дарину виправити збірку й додати чекліст у гайд для контриб’юторів.'
          },
          q: 'ok',
          fx: { team: -2, quality: 2 },
          fb: {
            en: 'The intention is right, but correcting a senior in public makes him defensive in public. The checklist is a good move; the venue was not.',
            ua: 'Намір правильний, але виправляти сеньйора публічно означає, що й захищатиметься він публічно. Чекліст — гарний крок; місце — ні.'
          }
        }
      ],
      principle: {
        en: 'Praise in public, correct in private, fix in pairs.',
        ua: 'Хвали публічно, виправляй приватно, лагодь парами.'
      }
    },
    {
      type: 'allocate',
      id: 's7',
      at: '15:30',
      comp: ['priorities', 'planning'],
      traits: ['E', 'I'],
      text: {
        en: "Four team-days remain before the demo. Split the team's time across the work that is left. Think about what the client will see on Thursday and what breaks after it.",
        ua: 'До демо лишилося чотири командо-дні. Розподіли час команди між роботою, що залишилась. Думай про те, що клієнт побачить у четвер і що зламається після.'
      },
      buckets: [
        {
          id: 'bug',
          label: { en: 'Checkout bug fixes', ua: 'Виправлення помилок оформлення' },
          hint: {
            en: '8% of live orders still fail at the address step.',
            ua: '8% живих замовлень досі падають на кроці адреси.'
          },
          best: 35
        },
        {
          id: 'payments',
          label: { en: 'Payment integration', ua: 'Інтеграція оплати' },
          hint: {
            en: 'Sandbox is down; the demo will use a stub either way.',
            ua: 'Пісочниця лежить; демо в будь-якому разі піде на заглушці.'
          },
          best: 15
        },
        {
          id: 'demo',
          label: { en: 'Demo path polish', ua: 'Шліфування сценарію демо' },
          hint: {
            en: 'The flow the CEO will click through on Thursday.',
            ua: 'Сценарій, який CEO проклікає в четвер.'
          },
          best: 35
        },
        {
          id: 'tests',
          label: { en: 'Test automation', ua: 'Автоматизація тестів' },
          hint: {
            en: "Would have caught today's red build.",
            ua: 'Зловила б сьогоднішню червону збірку.'
          },
          best: 15
        }
      ],
      explain: {
        en: "Live customers and the demo path get the lion's share: they are what the client feels this week. Payments cannot move while the sandbox is down, so a token share keeps the code warm. Tests earn a slice because Thursday is not the last day of the project.",
        ua: 'Живі клієнти й сценарій демо отримують левову частку: саме їх клієнт відчує цього тижня. Оплата не рухається, поки лежить пісочниця, тому символічна частка лише тримає код теплим. Тести заслуговують на частину, бо четвер — не останній день проєкту.'
      },
      fx: { ok: { delivery: 6, quality: 3 }, fail: { delivery: -5 } }
    },
    {
      type: 'chat',
      id: 's8',
      at: '17:20',
      comp: ['communication', 'risk'],
      traits: ['E', 'C'],
      messages: [
        {
          from: 'cto',
          text: {
            en: 'Before you send the client status: one line for me. Is Thursday happening or not? I have to tell the founders tonight.',
            ua: 'Перш ніж надішлеш статус клієнту: один рядок для мене. Четвер буде чи ні? Я маю сказати засновникам сьогодні.'
          }
        }
      ],
      prompt: {
        en: 'What goes to Olena, and in what form to Maryna?',
        ua: 'Що йде Олені, і в якій формі Марині?'
      },
      options: [
        {
          text: {
            en: 'To Olena: "Yes, with stubbed payments, forecast 37 of 48 points, risk: staging stability." To Maryna: the same three lines plus one decision she needs to make about gift wrapping.',
            ua: 'Олені: «Так, оплата на заглушці, прогноз 37 із 48 поінтів, ризик: стейджинг». Марині: ті самі три рядки плюс одне рішення щодо упаковки.'
          },
          q: 'best',
          fx: { trust: 6, delivery: 3 },
          fb: {
            en: 'Both readers get the same truth at the length they can act on. A decision request at the end turns a status into progress.',
            ua: 'Обидва читачі отримують ту саму правду в обсязі, з яким можуть працювати. Запит на рішення наприкінці перетворює статус на рух.'
          }
        },
        {
          text: {
            en: "A full written report to both: every ticket, every risk, the burndown chart and the provider's outage history, so nobody can say they were not told.",
            ua: 'Повний письмовий звіт обом: кожен тікет, кожен ризик, графік згоряння й історія падінь провайдера, щоб ніхто не сказав, що не знав.'
          },
          q: 'ok',
          fx: { trust: 1, energy: -8 },
          fb: {
            en: 'Complete, defensible and unread. Olena asked for one line because she needs one line; the detail belongs in an attachment.',
            ua: 'Повно, захищено й непрочитано. Олена просила один рядок, бо їй потрібен один рядок; деталі — у вкладенні.'
          }
        },
        {
          text: {
            en: 'To both: "Thursday is on track, the team did great work today." Details can wait until after the demo, when the picture is clearer.',
            ua: 'Обом: «Четвер за планом, команда сьогодні чудово попрацювала». Деталі почекають до після демо, коли картина проясниться.'
          },
          q: 'bad',
          fx: { trust: -8 },
          fb: {
            en: 'The picture is already clear and it has caveats. Every surprise on Thursday will now be yours, because you had the chance to say it today.',
            ua: 'Картина вже ясна, і в ній є застереження. Кожен сюрприз у четвер тепер твій, бо ти міг сказати про нього сьогодні.'
          }
        },
        {
          text: {
            en: 'Ask Olena for a 15-minute call instead of a line, and tell Maryna the status comes tomorrow morning once the staging issue is resolved.',
            ua: 'Попросити Олену про 15-хвилинний дзвінок замість рядка, а Марині сказати, що статус буде завтра вранці, коли вирішиться стейджинг.'
          },
          q: 'bad',
          fx: { trust: -5, energy: -3 },
          fb: {
            en: 'You turned two simple asks into two delays. Leaders who cannot summarise under pressure get replaced by ones who can.',
            ua: 'Ти перетворив два прості запити на дві затримки. Лідерів, які не вміють стисло під тиском, замінюють тими, хто вміє.'
          }
        }
      ],
      principle: {
        en: 'Status is three lines and a decision.',
        ua: 'Статус — це три рядки й одне рішення.'
      }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: {
          en: 'You could run this project tomorrow',
          ua: 'Ти міг би вести цей проєкт уже завтра'
        },
        text: {
          en: 'You re-planned instead of reporting, protected people in public and gave numbers under pressure. That is the senior pattern.',
          ua: 'Ти перепланував замість того, щоб звітувати, захищав людей публічно і давав цифри під тиском. Це патерн сеньйора.'
        }
      },
      {
        min: 0.6,
        title: {
          en: 'Solid middle PM with a few blind spots',
          ua: 'Впевнений мідл-ПМ із кількома сліпими зонами'
        },
        text: {
          en: 'Most calls were right; the misses were about timing, telling people later than they needed to hear it.',
          ua: 'Більшість рішень правильні; промахи стосувались часу, ти казав людям пізніше, ніж їм треба було почути.'
        }
      },
      {
        min: 0.4,
        title: {
          en: 'You would survive, but it would be loud',
          ua: 'Ти б вижив, але було б гучно'
        },
        text: {
          en: 'You tend to protect the plan instead of the people or the client. Re-read the feedback on the two chat scenes.',
          ua: 'Ти схильний захищати план, а не людей чи клієнта. Перечитай фідбек до двох чат-сцен.'
        }
      },
      {
        min: 0,
        title: { en: 'This day would have chewed you up', ua: 'Цей день тебе б пережував' },
        text: {
          en: 'Many choices optimised for being liked right now. The job is the opposite: say the costly thing early.',
          ua: 'Багато рішень були про те, щоб сподобатися зараз. Робота ж навпаки: казати дороге рано.'
        }
      }
    ],
    reality: [
      {
        en: 'About half the day is writing: statuses, re-plans, decisions logged so nobody has to ask twice.',
        ua: 'Близько половини дня — писання: статуси, переплани, зафіксовані рішення, щоб ніхто не питав двічі.'
      },
      {
        en: "You almost never build anything yourself. Your output is other people's unblocked afternoons.",
        ua: 'Ти майже ніколи нічого не робиш руками. Твій результат — чужі розблоковані дні.'
      },
      {
        en: 'Two or three times a week someone is upset with you for saying what something costs. That is the job working.',
        ua: 'Два-три рази на тиждень хтось на тебе ображається за те, що ти назвав ціну. Це означає, що робота працює.'
      }
    ]
  }
};
